<template>
  <div style="padding-bottom:20px">
    <div class="ad-form" v-for="(item, index) in adForm" :key="index">
      <p>第{{ index + 1 }}份广告</p>
      <div class="first-part">
        <van-field
          v-if="index === 0"
          readonly
          clickable
          name="picker"
          v-model="item.dealerType"
          label="门店类型"
          placeholder="请选择"
          @click="handleShopPicker(index)"
        />
        <van-divider v-if="index === 0" />
        <van-field
          v-if="index === 0"
          readonly
          clickable
          name="picker"
          v-model="productBrand"
          label="品牌类型"
          placeholder="请选择"
          @click="brandPicker = true"
        />
        <van-divider v-if="index === 0" />
        <van-field
          v-if="index === 0"
          readonly
          clickable
          name="picker"
          :value="adContent.advertType"
          label="广告类型"
          placeholder="门头招牌"
          @click="typePicker = false"
        />
        <van-divider v-if="index === 0" />
        <van-field
          readonly
          clickable
          name="picker"
          v-model="item.materialQuality"
          label="材质"
          placeholder="请选择"
          @click="handleTexturePicker(index)"
        />
        <van-divider />
        <div class="content-title">版面示例</div>
        <div class="example-img">
          <img
            :src="item.pageExample"
            alt
            style="width:100%;height:100%"
            ref="layoutImg"
          />
        </div>
      </div>
      <div class="second-part">
        <van-row type="flex">
          <van-col span="23">
            <van-field
              v-model="item.longs"
              type="number"
              label="广告长度"
              placeholder="请输入长度"
            />
          </van-col>
          <van-col span="1">米</van-col>
        </van-row>
        <van-divider />
        <van-row type="flex">
          <van-col span="23">
            <van-field
              v-model="item.height"
              type="number"
              label="广告高度"
              placeholder="请输入高度"
            />
          </van-col>
          <van-col span="1">米</van-col>
        </van-row>
        <van-divider />
        <div class="content-title">广告内容</div>
        <div class="ad-request">
          <van-field
            v-model="item.content"
            rows="2"
            autosize
            type="textarea"
            maxlength="100"
            placeholder="如对版面及内容有其他要求,请详细填写"
            show-word-limit
          />
        </div>
        <div class="content-title">
          <p>实景图片</p>
          <div class="img">
            <div
              class="edit-img"
              v-for="(img, indexes) in item.realSceneImg"
              :key="indexes"
            >
              <van-image
                width="88"
                height="88"
                fit="contain"
                :src="$imgPath + img"
                @click="previewImg"
              >
              </van-image>
              <van-icon name="clear" @click="handleDleteImg(index, indexes)" />
            </div>
            <van-uploader
              :name="index"
              v-model="fileList[index]"
              multiple
              :max-count="4"
              :after-read="afterRead"
              :before-delete="beforeDelete"
              :before-read="beforeRead"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="third-part">
      <div v-for="(item, index) in adForm" :key="index">
        第{{ index + 1 }}份广告预估费用:
        <span class="price">
          {{ item.estimateCost1 }}
        </span>
      </div>
      广告预估总费用: <span class="price">{{ estimateTotalCost1 }}</span>
    </div>
    <div class="tips">
      注意：系统预估的广告费用可能与广告实际安装的费用存在偏差；
      广告费用核销时，以哈弗公司财务部最终核算的金额为准。
    </div>
    <van-popup v-model="shopPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="shopColumns"
        @confirm="onShop"
        @cancel="shopPicker = false"
      />
    </van-popup>
    <van-popup v-model="brandPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="brandColumns"
        @confirm="onBrand"
        @cancel="brandPicker = false"
      />
    </van-popup>
    <van-popup v-model="typePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @confirm="onConfirm"
        @cancel="typePicker = false"
      />
    </van-popup>
    <van-popup v-model="texturePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="textureColumns"
        @confirm="onTexture"
        @cancel="texturePicker = false"
      />
    </van-popup>
    <van-button type="primary" @click="nextStep">下一步</van-button>
  </div>
</template>
<script>
import { Toast } from "vant";
import * as imageConversion from "image-conversion";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      shopColumns: ["汽修厂", "专卖店"],
      shopPicker: false,
      brandColumns: ["原动力", "力猛", "原动力+力猛"],
      brandPicker: false,
      typeColumns: ["门头招牌"],
      typePicker: false,
      textureColumns: [
        "纯灯布",
        "铁架+灯布",
        "彩钢板+PVC字",
        "铝塑板+PVC字",
        "铝塑板+平面发光字"
      ],
      texturePicker: false,
      adForm: [],
      adIndex: "",
      productBrand: "",
      adContent: {
        dealerType: null,
        advertType: "门头招牌",
        materialQuality: "",
        longs: "",
        height: "",
        content: "",
        realSceneImg: [],
        estimateCost1: null,
        estimateCost2: "123",
        pageExample: ""
      },
      fileList: [[], [], [], []],
      imgList: [[], [], [], []],
      adCopies: [],
      estimateTotalCost: 0
    };
  },
  filters: {
    dealerType(type) {
      switch (type) {
        case 1:
          return "汽修厂";
        case 2:
          return "专卖店";
        default:
          break;
      }
    },
    productBrandFilter(type) {
      switch (type) {
        case "1":
          return "原动力";
        case "2":
          return "力猛";
        case "3":
          return "原动力+力猛";
        default:
          break;
      }
    },
    materialQuality(type) {
      switch (type) {
        case 1:
          return "铁架+灯布";
        case 2:
          return "彩钢板+PVC";
        case 3:
          return "铝塑板+PVC字";
        case 4:
          return "铝塑板+平面发光字";
        case 5:
          return "纯灯布";
        default:
          break;
      }
    }
  },
  watch: {
    adForm: {
      handler: function(newVal) {
        newVal.forEach((val, index) => {
          switch (newVal[index].materialQuality) {
            case "纯灯布": {
              let adPrice = Math.ceil(
                40 * newVal[index].longs * newVal[index].height * 1.5
              );
              adPrice = adPrice < 300 && adPrice > 0 ? 300 : adPrice;
              newVal[index].estimateCost1 = adPrice;
              break;
            }
            case "铁架+灯布": {
              let adPrice = Math.ceil(
                70 * newVal[index].longs * newVal[index].height * 1.5
              );
              adPrice = adPrice < 300 && adPrice > 0 ? 300 : adPrice;
              newVal[index].estimateCost1 = adPrice;
              break;
            }
            case "彩钢板+PVC字": {
              let adPrice = Math.ceil(
                240 * newVal[index].longs * newVal[index].height * 1.5
              );
              adPrice = adPrice < 500 && adPrice > 0 ? 500 : adPrice;
              newVal[index].estimateCost1 = adPrice;
              break;
            }
            case "铝塑板+PVC字": {
              let adPrice = Math.ceil(
                270 * newVal[index].longs * newVal[index].height * 1.5
              );
              adPrice = adPrice < 500 && adPrice > 0 ? 500 : adPrice;
              newVal[index].estimateCost1 = adPrice;
              break;
            }
            case "铝塑板+平面发光字": {
              let adPrice = Math.ceil(
                340 * newVal[index].longs * newVal[index].height * 1.5
              );
              adPrice = adPrice < 800 && adPrice > 0 ? 800 : adPrice;
              newVal[index].estimateCost1 = adPrice;
              break;
            }
            default:
              return 0;
          }
        });
      },
      deep: true
    }
  },
  computed: {
    estimateCost1: function() {
      switch (this.adContent.materialQuality) {
        case "纯灯布": {
          let adPrice = Math.ceil(
            40 * this.adContent.longs * this.adContent.height * 1.5
          );
          adPrice = adPrice < 300 && adPrice > 0 ? 300 : adPrice;
          return adPrice;
        }
        case "铁架+灯布": {
          let adPrice = Math.ceil(
            70 * this.adContent.longs * this.adContent.height * 1.5
          );
          adPrice = adPrice < 300 && adPrice > 0 ? 300 : adPrice;
          return adPrice;
        }
        case "彩钢板+PVC字": {
          let adPrice = Math.ceil(
            240 * this.adContent.longs * this.adContent.height * 1.5
          );
          adPrice = adPrice < 500 && adPrice > 0 ? 500 : adPrice;
          return adPrice;
        }
        case "铝塑板+PVC字": {
          let adPrice = Math.ceil(
            270 * this.adContent.longs * this.adContent.height * 1.5
          );
          adPrice = adPrice < 500 && adPrice > 0 ? 500 : adPrice;
          return adPrice;
        }
        case "铝塑板+平面发光字": {
          let adPrice = Math.ceil(
            340 * this.adContent.longs * this.adContent.height * 1.5
          );
          adPrice = adPrice < 800 && adPrice > 0 ? 800 : adPrice;
          return adPrice;
        }
        default:
          return 0;
      }
    },
    estimateTotalCost1: function() {
      let totalPrice = 0;
      this.adForm.forEach(val => {
        totalPrice += val.estimateCost1;
      });
      return totalPrice;
    }
  },
  created() {
    this.initForm();
  },
  methods: {
    // 表单渲染
    initForm() {
      this.adForm = JSON.parse(localStorage.getItem("content"));
      this.adForm.forEach(val => {
        switch (val.dealerType) {
          case 1:
            val.dealerType = "汽修厂";
            break;
          case 2:
            val.dealerType = "专卖店";
            break;
          default:
            break;
        }
        switch (val.materialQuality) {
          case 1:
            val.materialQuality = "铁架+灯布";
            break;
          case 2:
            val.materialQuality = "彩钢板+PVC字";
            break;
          case 3:
            val.materialQuality = "铝塑板+PVC字";
            break;
          case 4:
            val.materialQuality = "铝塑板+平面发光字";
            break;
          case 5:
            val.materialQuality = "纯灯布";
            break;
          default:
            break;
        }
        if (val.realSceneImg.length != 0) {
          val.realSceneImg = val.realSceneImg.split(",");
        } else {
          val.realSceneImg = [];
        }
      });
      switch (localStorage.getItem("productBrand")) {
        case "1":
          this.productBrand = "原动力";
          break;
        case "2":
          this.productBrand = "力猛";
          break;
        case "3":
          this.productBrand = "原动力+力猛";
          break;
        default:
          break;
      }
    },
    // 门店类型
    handleShopPicker(index) {
      this.shopPicker = true;
      this.adIndex = index;
    },
    onShop(value, index) {
      if (index === 0) {
        switch (this.adForm[this.adIndex].materialQuality) {
          case "纯灯布":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/factory_stand.jpg");
            break;
          case "铁架+灯布":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/factory_stand.jpg");
            break;
          case "彩钢板+PVC字":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/factory_panel_PVC.jpg");
            break;
          case "铝塑板+PVC字":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/factory_plate_PVC.jpg");
            break;
          case "铝塑板+平面发光字":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/factory_plate_character.jpg");
            break;
          default:
            this.adForm[this.adIndex].pageExample = "";
            break;
        }
      } else {
        switch (this.adForm[this.adIndex].materialQuality) {
          case "纯灯布":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/shop_stand.jpg");
            break;
          case "铁架+灯布":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/shop_stand.jpg");
            break;
          case "彩钢板+PVC字":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/shop_panel_PVC.jpg");
            break;
          case "铝塑板+PVC字":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/shop_plate_PVC.jpg");
            break;
          case "铝塑板+平面发光字":
            this.adForm[
              this.adIndex
            ].pageExample = require("../../assets/shop_plate_character.jpg");
            break;
          default:
            this.adForm[this.adIndex].pageExample = "";
            break;
        }
      }
      this.adForm[this.adIndex].dealerType = value;
      this.shopPicker = false;
    },
    // 品牌类型
    onBrand(value) {
      this.productBrand = value;
      this.brandPicker = false;
    },
    // 广告类型
    onConfirm(value) {
      this.adContent.advertType = value;
      this.typePicker = false;
    },
    // 材质
    handleTexturePicker(index) {
      this.texturePicker = true;
      this.adIndex = index;
    },
    onTexture(value, index) {
      if (this.adForm[this.adIndex].dealerType === null) {
        Toast("请选择门店类型");
        this.texturePicker = false;
        return;
      }
      switch (index) {
        case 0:
          this.adForm[this.adIndex].pageExample =
            this.adForm[this.adIndex].dealerType === "汽修厂"
              ? require("../../assets/factory_stand.jpg")
              : require("../../assets/shop_stand.jpg");
          break;
        case 1:
          this.adForm[this.adIndex].pageExample =
            this.adForm[this.adIndex].dealerType === "汽修厂"
              ? require("../../assets/factory_panel_PVC.jpg")
              : require("../../assets/shop_panel_PVC.jpg");
          break;
        case 2:
          this.adForm[this.adIndex].pageExample =
            this.adForm[this.adIndex].dealerType === "汽修厂"
              ? require("../../assets/factory_plate_PVC.jpg")
              : require("../../assets/shop_plate_PVC.jpg");
          break;
        case 3:
          this.adForm[this.adIndex].pageExample =
            this.adForm[this.adIndex].dealerType === "汽修厂"
              ? require("../../assets/factory_plate_character.jpg")
              : require("../../assets/shop_plate_character.jpg");
          break;
        default:
          break;
      }
      this.adForm[this.adIndex].materialQuality = value;
      this.texturePicker = false;
    },
    // 上传图片前
    beforeRead(file) {
      return new Promise(resolve => {
        const isLt2M = file.size / 1024 < 900;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 900).then(res => {
            let files = new window.File([res], file.name, {
              type: file.type
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file, detail) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then(res => {
          // console.log(res);
          file.status = "done";
          file.message = "上传成功";
          this.imgList[detail.name].push(res.url);
        })
        .catch(err => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          Toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete(file, detail) {
      this.fileList[detail.name].splice(detail.index, 1);
      this.imgList[detail.name].splice(detail.index, 1);
    },
    handleDleteImg(index, indexes) {
      this.adForm[index].realSceneImg.splice(indexes, 1);
    },
    // 下一步
    nextStep() {
      if (!this.handleRules()) {
        return;
      }
      this.filterData();
      // console.log(this.adForm);
      localStorage.setItem("content", JSON.stringify(this.adForm));
      localStorage.setItem("productBrand", this.productBrand);
      localStorage.setItem("estimateTotalCost", this.estimateTotalCost);
      // sessionStorage.removeItem("apply");
      this.$router.push({
        path: "/agency/ad-agreement",
        query: {
          type: "edit"
        }
      });
    },
    //校验
    handleRules() {
      this.adForm.forEach(val => {
        if (val.dealerType === null) {
          this.$toast("请选择门店类型");
          return false;
        }
        if (val.materialQuality === "") {
          this.$toast("请选择材质");
          return false;
        }
        if (val.longs.trim() === "") {
          this.$toast("请输入广告长度");
          return false;
        }
        if (val.height.trim() === "") {
          this.$toast("请输入广告高度");
          return false;
        }
        if (val.content.trim() === "") {
          this.$toast("请输入广告内容");
          return false;
        }
        if (val.realSceneImg.length === 0) {
          this.$toast("请上传实景图片");
          return false;
        }
      });
      return true;
    },
    //数据过滤
    filterData() {
      // 品牌类型
      switch (this.productBrand) {
        case "原动力":
          this.productBrand = 1;
          break;
        case "力猛":
          this.productBrand = 2;
          break;
        case "原动力+力猛":
          this.productBrand = 3;
          break;
      }
      //总价
      this.estimateTotalCost = this.estimateTotalCost1;
      this.adForm.forEach((val, index) => {
        //门店类型
        val.dealerType = val.dealerType === "汽修厂" ? 1 : 2;
        //材质
        switch (val.materialQuality) {
          case "铁架+灯布":
            val.materialQuality = 1;
            break;
          case "彩钢板+PVC字":
            val.materialQuality = 2;
            break;
          case "铝塑板+PVC字":
            val.materialQuality = 3;
            break;
          case "铝塑板+平面发光字":
            val.materialQuality = 4;
            break;
          case "纯灯布":
            val.materialQuality = 5;
            break;
        }
        // 示例图
        val.pageExample = this.$refs.layoutImg[index].src;
        // 实景图
        let realSceneImgArr = val.realSceneImg.concat(this.imgList[index]);
        val.realSceneImg =
          realSceneImgArr.length === 0 ? "" : realSceneImgArr.join(",");
      });
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell {
  padding: 0;
}

.van-cell:nth-of-type(1) {
  padding-top: 16px;
}

.van-cell:not(:last-child)::after {
  display: none;
}

.van-divider {
  border-color: #eaeaea;
}

.first-part {
  padding: 0 20px;
  border-bottom: 15px solid #eaeaea;

  .example-img {
    width: 100%;
    height: 200px;
    margin: 0 auto;
    margin-bottom: 10px;
    border: 1px solid #eaeaea;
  }
}

.second-part {
  padding: 0 20px;
  border-bottom: 15px solid #eaeaea;
}

.third-part {
  text-align: left;
  padding: 20px 20px;

  .price {
    color: red;
  }
}

.tips {
  padding: 20px;
  padding-top: 0;
  font-size: 14px;
  text-align: left;
  color: red;
}

.content-title {
  margin-bottom: 5px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;

  .img {
    display: flex;
    align-items: center;

    .van-image {
      margin-right: 5px;
    }

    .edit-img {
      position: relative;

      .van-icon {
        position: absolute;
        top: 0;
        right: 5px;
        color: #969799;
        font-size: 18px;
      }
    }
  }
}

.add-ad {
  margin-right: 20px;
}

.van-row--flex {
  align-items: baseline;
}
</style>
<style lang="scss">
.van-field__control {
  text-indent: 70px;
}

.van-field__label {
  text-align: left;
  font-weight: 600;
}

.ad-request {
  margin-bottom: 20px;
  border: 1px solid #eaeaea;

  .van-field__control {
    text-indent: 10px;
  }

  .van-cell:nth-of-type(1) {
    padding-top: 0;
  }
}

.van-uploader__upload {
  background-color: #ccc;
}

.van-uploader {
  position: static;
}
</style>
